import {
  ReportTemplateAddressLookup,
  ReportTemplateAdverseMedia,
  ReportTemplateAttributes,
  ReportTemplateAttributesCustomList,
  ReportTemplateAttributesWatchlist,
  ReportTemplateBusinessAdverseMedia,
  ReportTemplateBusinessAssociatedPersons,
  ReportTemplateBusinessClassification,
  ReportTemplateBusinessIndustryClassification,
  ReportTemplateBusinessLiensLookup,
  ReportTemplateBusinessLookup,
  ReportTemplateBusinessNonprofit,
  ReportTemplateBusinessOnlinePresence,
  ReportTemplateBusinessRegistrationsLookup,
  ReportTemplateBusinessSocialMedia,
  ReportTemplateBusinessWatchlist,
  ReportTemplateBusinessWebsite,
  ReportTemplateChainalysisAddressScreening,
  ReportTemplateCryptoAddressWatchlist,
  ReportTemplateCustomList,
  ReportTemplateEmailAddress,
  ReportTemplateFinraBrokerCheck,
  ReportTemplateMxAccount,
  ReportTemplatePhoneNumber,
  ReportTemplatePoliticallyExposedPerson,
  ReportTemplateProfile,
  ReportTemplateProfileNonAuthoritative,
  ReportTemplateSecActionLookup,
  ReportTemplateSentilinkApplicationRisk,
  ReportTemplateSentilinkScores,
  ReportTemplateSocialMedia,
  ReportTemplateSynthetic,
  ReportTemplateWatchlist,
} from 'dashboard/models/report-template';
import { ApiModel } from 'lib/interfaces/api';

const updatedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewReportTemplateAddressLookup(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateAddressLookup {
  return {
    id: id || 'rptp_000',
    type: ApiModel.ReportTemplateAddressLookup,
    attributes: {
      name: 'Address Lookup Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateAdverseMedia(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateAdverseMedia {
  return {
    id: id || 'rptp_001',
    type: ApiModel.ReportTemplateAdverseMedia,
    attributes: {
      name: 'Adverse Media Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessLiensLookup(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessLiensLookup {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessLiensLookup,
    attributes: {
      name: 'Business Liens Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessLookup(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessLookup {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessLookup,
    attributes: {
      name: 'Business Lookup Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessNonprofit(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessNonprofit {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessNonprofit,
    attributes: {
      name: 'Business Nonprofit Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessOnlinePresence(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessOnlinePresence {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessOnlinePresence,
    attributes: {
      name: 'Business Online Presence Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}
export function createPreviewReportTemplateBusinessAdverseMedia(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessAdverseMedia {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessAdverseMedia,
    attributes: {
      name: 'Business Adverse Media Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessAssociatedPersons(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessAssociatedPersons {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessAssociatedPersons,
    attributes: {
      name: 'Business Associated Persons Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessClassification(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessClassification {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessClassification,
    attributes: {
      name: 'Business Classification Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessIndustryClassification(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessIndustryClassification {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessIndustryClassification,
    attributes: {
      name: 'Business Industry Classification Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessRegistrationsLookup(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessRegistrationsLookup {
  return {
    id: id || 'rptp_003',
    type: ApiModel.ReportTemplateBusinessRegistrationsLookup,
    attributes: {
      name: 'Business Registrations Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessSocialMedia(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessSocialMedia {
  return {
    id: id || 'rptp_0003',
    type: ApiModel.ReportTemplateBusinessSocialMedia,
    attributes: {
      name: 'Business Social Media Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessWatchlist(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessWatchlist {
  return {
    id: id || 'rptp_004',
    type: ApiModel.ReportTemplateBusinessWatchlist,
    attributes: {
      name: 'Business Watchlist Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateBusinessWebsite(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateBusinessWebsite {
  return {
    id: id || 'rptp_004',
    type: ApiModel.ReportTemplateBusinessWebsite,
    attributes: {
      name: 'Business Website Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateChainalysisAddressScreening(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateChainalysisAddressScreening {
  return {
    id: id || 'rptp_0008',
    type: ApiModel.ReportTemplateChainalysisAddressScreening,
    attributes: {
      name: 'Chainalysis Address Screening Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateCryptoAddressWatchlist(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateCryptoAddressWatchlist {
  return {
    id: id || 'rptp_005',
    type: ApiModel.ReportTemplateCryptoAddressWatchlist,
    attributes: {
      name: 'Crypto Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateEmailAddress(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateEmailAddress {
  return {
    id: id || 'rptp_006',
    type: ApiModel.ReportTemplateEmailAddress,
    attributes: {
      name: 'Email Risk Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateFinraBrokerCheck(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateFinraBrokerCheck {
  return {
    id: id || 'rptp_007',
    type: ApiModel.ReportTemplateFinraBrokerCheck,
    attributes: {
      name: 'Finra Broker Check Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateMxAccount(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateMxAccount {
  return {
    id: id || 'rptp_0007',
    type: ApiModel.ReportTemplateMxAccount,
    attributes: {
      name: 'Mx Account Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplatePhoneNumber(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplatePhoneNumber {
  return {
    id: id || 'rptp_008',
    type: ApiModel.ReportTemplatePhoneNumber,
    attributes: {
      name: 'Phone Risk Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplatePoliticallyExposedPerson(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplatePoliticallyExposedPerson {
  return {
    id: id || 'rptp_009',
    type: ApiModel.ReportTemplatePoliticallyExposedPerson,
    attributes: {
      name: 'PEP Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateProfile(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateProfile {
  return {
    id: id || 'rptp_0001',
    type: ApiModel.ReportTemplateProfile,
    attributes: {
      name: 'Profile Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateProfileNonAuthoritative(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateProfileNonAuthoritative {
  return {
    id: id || 'rptp_0003',
    type: ApiModel.ReportTemplateProfileNonAuthoritative,
    attributes: {
      name: 'Profile Non-Authoritative Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateSecActionLookup(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateSecActionLookup {
  return {
    id: id || 'rptp_0002',
    type: ApiModel.ReportTemplateSecActionLookup,
    attributes: {
      name: 'Sec Action Lookup Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateSentilinkScores(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateSentilinkScores {
  return {
    id: id || 'rptp_0006',
    type: ApiModel.ReportTemplateSentilinkScores,
    attributes: {
      name: 'Sentilink Scores Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateSentilinkApplicationRisk(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateSentilinkApplicationRisk {
  return {
    id: id || 'rptp_0006',
    type: ApiModel.ReportTemplateSentilinkApplicationRisk,
    attributes: {
      name: 'Sentilink Application Risk Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateSocialMedia(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateSocialMedia {
  return {
    id: id || 'rptp_0003',
    type: ApiModel.ReportTemplateSocialMedia,
    attributes: {
      name: 'Social Media Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateSynthetic(
  attributes?: Partial<ReportTemplateAttributes>,
  id?: string,
): ReportTemplateSynthetic {
  return {
    id: id || 'rptp_0004',
    type: ApiModel.ReportTemplateSynthetic,
    attributes: {
      name: 'Synthetic Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateWatchlist(
  attributes?: Partial<ReportTemplateAttributesWatchlist>,
  id?: string,
): ReportTemplateWatchlist {
  return {
    id: id || 'rptp_0005',
    type: ApiModel.ReportTemplateWatchlist,
    attributes: {
      name: 'Watchlist Report Template',
      archived: false,
      'updated-at': updatedAt,
      'latest-published-version': {
        id: 12,
        config: {},
      },
      ...attributes,
    },
    relationships: {},
  };
}

export function createPreviewReportTemplateCustomList(
  attributes?: Partial<ReportTemplateAttributesCustomList>,
  id?: string,
): ReportTemplateCustomList {
  return {
    id: id || 'rptp_0006',
    type: ApiModel.ReportTemplateCustomList,
    attributes: {
      name: 'Custom List Report Template',
      archived: false,
      'updated-at': updatedAt,
      'version-history': [],
      'run-history': [],
      ...attributes,
    },
    relationships: {
      'latest-published-version': {
        data: {
          id: 'rptv_0006',
          type: ApiModel.ReportTemplateVersionCustomList,
        },
      },
    },
  };
}
